export default __webpack_public_path__ + "static/presse-huettn-2-download-4c9fc185883e2614dbf65927e3e397e9.jpg";